import { fetch } from '@/services/Fetch'

export interface RegisterUser {
  userType: string
  firstName: string
  lastName: string
  email: string
  password: string
  optOut: string
  language: string
}

export interface SocialRegisterUser {
  userType: string
  password: string
  optOut: string
  language: string
}

export interface UpdateCustomerProfileData {
  '@id': string
  userTitle: string
  firstName: string
  lastName: string
  email: string
  telephone: string
  mobilePhone: string
  faxNumber: string
  timezone: string
}

export const registerCustomer = (data: RegisterUser) => {
  const url = 'customers/register'

  const options = {
    method: 'POST',
    data
  }

  return fetch(url, options)
}

export const updateCustomer = (data: any) => {
  const options = {
    method: 'PUT',
    data
  }
  return fetch(data['@id'], options)
}

export const socialRegisterCustomerFinalize = (data: SocialRegisterUser) => {
  const url = 'customers/social/finalize'

  const options = {
    method: 'POST',
    data
  }

  return fetch(url, options)
}